/** Row ids. Random for most rows; deterministic (UUIDv5) for rows that must be
 *  one-per-user-per-thing, so two offline devices create the SAME row — a day's
 *  status, the profile — instead of two that fight. */

export function newId(): string {
  const c = globalThis.crypto as Crypto
  if (typeof c.randomUUID === 'function') return c.randomUUID()
  // Very old WebViews: RFC 4122 v4 from getRandomValues.
  const b = c.getRandomValues(new Uint8Array(16))
  b[6] = (b[6] & 0x0f) | 0x40
  b[8] = (b[8] & 0x3f) | 0x80
  return hex(b)
}

function hex(b: Uint8Array): string {
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('')
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}

const NS = '9c1e8f52-6b0e-4d7a-a2f4-3d1c5b7e9a60'

export async function stableId(name: string): Promise<string> {
  const ns = NS.replace(/-/g, '').match(/../g)!.map((x) => parseInt(x, 16))
  const data = new Uint8Array([...ns, ...new TextEncoder().encode(name)])
  const digest = new Uint8Array(await crypto.subtle.digest('SHA-1', data)).slice(0, 16)
  digest[6] = (digest[6] & 0x0f) | 0x50
  digest[8] = (digest[8] & 0x3f) | 0x80
  return hex(digest)
}
